import React, { useState } from 'react';

const industries = [
  { name: 'Insurance', use: 'Policy sales · Renewals · Claims' },
  { name: 'Healthcare', use: 'Appointments · Outreach · Care mgmt' },
  { name: 'Telecoms', use: 'Upgrades · Churn prevention · Win-back' },
  { name: 'Energy', use: 'Switching · Smart meters · Tariffs' },
  { name: 'Technology', use: 'SaaS demos · Trial conversion · Upsell' },
  { name: 'FinServ', use: 'Debt mgmt · Mortgages · Regulated outbound' },
  { name: 'Retail', use: 'Loyalty · Post-purchase · Feedback' },
  { name: 'Enterprise', use: 'Custom setup · Personal support · Built for you' },
];

export default function Industries() {
  const [hovered, setHovered] = useState(null);

  return (
    <section style={{ maxWidth: 960, margin: '0 auto', padding: '5rem 2.5rem' }}>
      <div style={tag}>// VERTICALS</div>
      <h2 style={head}>Built for <span style={{ color: '#0a9e8f' }}>your industry.</span></h2>
      <div className="industries-grid" style={{ marginTop: '2.5rem', background: 'rgba(10,158,143,0.13)', border: '1px solid rgba(10,158,143,0.13)', borderRadius: 12, overflow: 'hidden' }}>
        {industries.map((ind, i) => (
          <div key={i}
            onMouseEnter={() => setHovered(i)}
            onMouseLeave={() => setHovered(null)}
            style={{ background: hovered === i ? '#161616' : '#060606', padding: '1.5rem 1.25rem', cursor: 'default', transition: 'background .2s', borderLeft: hovered === i ? '2px solid #077a6e' : '2px solid transparent' }}>
            <div style={{ fontSize: '0.9375rem', fontWeight: 600, color: '#f0f0f0', marginBottom: 8 }}>{ind.name}</div>
            <div style={{ fontSize: '0.72rem', color: '#909090', lineHeight: 1.5 }}>{ind.use}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

const tag = { fontSize: '0.68rem', color: '#077a6e', fontFamily: "'JetBrains Mono', monospace", letterSpacing: '0.1em', marginBottom: 12, borderLeft: '2px solid #056055', paddingLeft: 10 };
const head = { fontSize: 'clamp(1.6rem,3vw,2.2rem)', fontWeight: 700, letterSpacing: '-0.03em', color: '#f0f0f0' };
